import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { appRoutes } from './app.routes';
import { AppComponent } from './app.component';

import { APP_BASE_HREF } from '@angular/common'; 
import { langsPath } from '@unpispas/upp-base';
import { UppBaseModule } from '@unpispas/upp-base';
import { UppKonvaDemoModule } from '@unpispas/upp-konva-demo';
import { UppWdgtModule } from '@unpispas/upp-wdgt';

import { uppBaseTesterComponent } from './tester/test-base';

import { DemoShellComponent } from './demos/demo-shell';
import { DemoApplicationShellComponent } from './demos/demo-application-shell';
import { DemoLayoutComponent } from './demos/demo-layout';
import { DemoGridComponent } from './demos/demo-grid';
import { DemoFormControlsComponent } from './demos/demo-form-controls';
import { DemoSelectComponent } from './demos/demo-select';
import { DemoMediaComponent } from './demos/demo-media';
import { DemoNavigationComponent } from './demos/demo-navigation';
import { DemoFormLayoutComponent } from './demos/demo-form-layout';

import { DemoUppInputComponent } from './demos/widgets/demo-upp-input';
import { DemoUppInputSelectComponent } from './demos/widgets/demo-upp-input-select';
import { DemoUppTextareaComponent } from './demos/widgets/demo-upp-textarea';
import { DemoUppSearchComponent } from './demos/widgets/demo-upp-search';
import { DemoUppSelectComponent } from './demos/widgets/demo-upp-select';
import { DemoUppPanelComponent } from './demos/widgets/demo-upp-panel';
import { DemoUppDialogComponent } from './demos/widgets/demo-upp-dialog';
import { DemoUppHeaderComponent } from './demos/widgets/demo-upp-header';
import { DemoUppSideMenuComponent } from './demos/widgets/demo-upp-side-menu';
import { DemoUppApplicationComponent } from './demos/widgets/demo-upp-application';
import { DemoUppDropdownComponent } from './demos/widgets/demo-upp-dropdown';
import { DemoUppScrollableComponent } from './demos/widgets/demo-upp-scrollable';
import { DemoUppVisibleControlComponent } from './demos/widgets/demo-upp-visible-control';
import { DemoUppGridComponent } from './demos/widgets/demo-upp-grid';
import { DemoUppThumbComponent } from './demos/widgets/demo-upp-thumb';
import { DemoUppImageComponent } from './demos/widgets/demo-upp-image';
import { DemoUppFormComponent } from './demos/widgets/demo-upp-form';
import { DemoUppTabBarComponent } from './demos/widgets/demo-upp-tab-bar';
import { DemoUppAddressComponent } from './demos/widgets/demo-upp-address';
import { DemoUppButtonBarComponent } from './demos/widgets/demo-upp-button-bar';
import { DemoUppDatePickerComponent } from './demos/widgets/demo-upp-date-picker';
import { DemoUppTimeComponent } from './demos/widgets/demo-upp-time';
import { DemoUppChartComponent } from './demos/widgets/demo-upp-chart';
import { DemoUppColorComponent } from './demos/widgets/demo-upp-color';
import { DemoUppBarcodeDisplayComponent } from './demos/widgets/demo-upp-barcode-display';
import { DemoUppScaleInputComponent } from './demos/widgets/demo-upp-scale-input';

@NgModule({
    declarations: [
        AppComponent,
        uppBaseTesterComponent,
        DemoShellComponent,
        DemoApplicationShellComponent,
        DemoLayoutComponent,
        DemoGridComponent,
        DemoFormControlsComponent,
        DemoSelectComponent,
        DemoMediaComponent,
        DemoNavigationComponent,
        DemoFormLayoutComponent,
        DemoUppInputComponent,
        DemoUppInputSelectComponent,
        DemoUppTextareaComponent,
        DemoUppSearchComponent,
        DemoUppSelectComponent,
        DemoUppPanelComponent,
        DemoUppDialogComponent,
        DemoUppHeaderComponent,
        DemoUppSideMenuComponent,
        DemoUppApplicationComponent,
        DemoUppDropdownComponent,
        DemoUppScrollableComponent,
        DemoUppVisibleControlComponent,
        DemoUppGridComponent,
        DemoUppThumbComponent,
        DemoUppImageComponent,
        DemoUppFormComponent,
        DemoUppTabBarComponent,
        DemoUppAddressComponent,
        DemoUppButtonBarComponent,
        DemoUppDatePickerComponent,
        DemoUppTimeComponent,
        DemoUppChartComponent,
        DemoUppColorComponent,
        DemoUppBarcodeDisplayComponent,
        DemoUppScaleInputComponent,
    ],
    imports: [
        BrowserModule, 
        // Hash routing: deep links work when the host only serves index.html at /upp-test/
        // (no Nginx try_files / SPA fallback for child paths).
        RouterModule.forRoot(appRoutes, { useHash: true }),
        FormsModule,
        ReactiveFormsModule,
        UppBaseModule,
        UppKonvaDemoModule,
        UppWdgtModule,
        IonicModule.forRoot()
    ],
    providers: [
        { provide: APP_BASE_HREF, useValue: document.querySelector('base')?.getAttribute('href') || '/' },
        { provide: langsPath, useFactory: (baseHref: string) => `${baseHref}langs`, deps: [APP_BASE_HREF] }
    ],    
      bootstrap: [
        AppComponent
    ],
})
export class AppModule {}
